import React from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import InputTextComponent, {
  type InputTextProps,
} from '../../styled-components/components/InputText';

type InputProps = InputTextProps & {
  register?: UseFormRegisterReturn;
};
const InputText = ({ id, ...props }: Omit<InputProps, 'ref'>) => {
  return (
    <InputTextComponent
      id={id || props.register ? `id-${props?.register?.name}` : undefined}
      {...props}
    />
  );
};

export default InputText;
